module.exports = __webpack_public_path__ + "static/media/recharging-your-battery@3x.bd6fd781.png";